import { forwardRef } from "react"
import { BaseLabel, BaseHint } from "./styles"

type HTMLLabelProps = Omit<React.LabelHTMLAttributes<HTMLLabelElement>, "size">

interface ILabel
  extends React.ForwardRefExoticComponent<
    LabelProps & React.RefAttributes<HTMLLabelElement>
  > {
  Hint: React.FC<React.HTMLAttributes<HTMLSpanElement>>
}
export interface LabelProps extends HTMLLabelProps {}

const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className = "", ...props }, ref) => {
    return (
      <BaseLabel
        ref={ref}
        className={`caption-heavy ${className}`}
        {...props}
      />
    )
  }
) as ILabel

Label.Hint = ({ className = "", ...props }) => (
  <BaseHint className={`caption ${className}`} {...props} />
)

Label.displayName = "Label"
Label.Hint.displayName = "Hint"

export default Label
